import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ChannelNumbersState } from '../promote/channels/channelNumbersState';
import { channelNumbersMessages } from '../promote/channels/channelNumbersMessages';
import { SerializedSocialChannel } from '../promote/types';
import { socialMessages as messages } from './socialMessages';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialTotalStateLineProps {
  channel: Pick<SerializedSocialChannel, 'lastSyncedAt'>;
  state: ChannelNumbersState;
}

/**
 * The plain line of a totals card with no numbers. No button: the Reconnect is in Channels
 * (design your-intelligence g1).
 */
const SocialTotalStateLineComponent: React.FC<SocialTotalStateLineProps> = ({ channel, state }) => {
  const intl = useIntl();

  if (state === 'reading') {
    return <div className={styles.signedOutLine}>{intl.formatMessage(channelNumbersMessages.reading)}</div>;
  }
  if (state === 'reconnect') {
    const date =
      channel.lastSyncedAt === null ? '—' : intl.formatDate(channel.lastSyncedAt, { day: 'numeric', month: 'short' });
    return <div className={styles.signedOutLine}>{intl.formatMessage(messages.signedOutLine, { date })}</div>;
  }
  if (state === 'reconnectForNumbers') {
    return <div className={styles.signedOutLine}>{withBrandWord(intl.formatMessage(messages.readScopeLine))}</div>;
  }
  return null;
};

export const SocialTotalStateLine = TypedMemo(SocialTotalStateLineComponent);
